import React from 'react';

interface Props extends React.ComponentProps<'dd'> {}

const DefinitionListTerm: React.FC<Props> = ({
  children,
  ...rest
}) => {
  return (
    <dt {...rest}>
      {children}
    </dt>
  );
};

export default DefinitionListTerm;
